import NoData from "components/NoData/NoData.view";
import { useStyles } from "./ReportCard.styles";
import { IReportCard } from "./ReportCardInterfaces";

const ReportCard = ({
    title,
    children,
    showNoData,
    noDataTitle,
    headerActions,
    className,
    headerActionsClassName,
    headerClassName,
}: IReportCard) => {
    const classes = useStyles();

    return (
        <div className={`${classes.gridItem} ${className ? className : ""}`}>
            {title && (
                <div className={`${classes.headerTitle} ${headerClassName ? headerClassName : ""}`}>
                    {title}
                    {!!headerActions && (
                        <div
                            className={`${classes.headerActions} ${
                                headerActionsClassName ? headerActionsClassName : ""
                            }`}
                        >
                            {headerActions}
                        </div>
                    )}
                </div>
            )}
            <div className={classes.content}>
                {showNoData ? <NoData className={classes.noData} title={noDataTitle} /> : children}
            </div>
        </div>
    );
};

export default ReportCard;
